// Shared Oracle client helpers — used by the in-headquarters workspace.
export const ORACLE_API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MEMBER_TOKEN_KEY = "archive_member_token";
const OP_TOKEN_KEY = "archive-admin-token";

// Send whatever credentials the browser holds; the backend resolves the
// highest available clearance and filters every answer accordingly.
export const oracleAuthHeaders = () => {
  const h = {};
  const op = localStorage.getItem(OP_TOKEN_KEY);
  const mem = localStorage.getItem(MEMBER_TOKEN_KEY);
  if (op) h["x-admin-token"] = op;
  if (mem) h["Authorization"] = `Bearer ${mem}`;
  return h;
};

export const CLEARANCE_TONE = {
  "FOUNDER CLEARANCE": "#D92D20",
  "EXECUTIVE CLEARANCE": "#C58A2E",
  "EDITORIAL CLEARANCE": "#A68F5E",
  "RESEARCH CLEARANCE": "#6E8E8A",
  "COMMUNITY CLEARANCE": "#7E7BA6",
  "VERIFICATION CLEARANCE": "#5E9E7A",
  "MEMBER CLEARANCE": "#8A8377",
  "PUBLIC CLEARANCE": "#5A554C",
};

// Short-lived sessionStorage cache for deterministic GETs (briefing, /me)
// so re-opening Oracle feels instant. Keyed to the caller's credentials so
// a login/logout or role change never serves stale clearance data.
const CACHE_TTL_MS = 5 * 60 * 1000;

const authSignature = () => {
  const h = oracleAuthHeaders();
  return `${(h["x-admin-token"] || "").slice(0, 8)}:${(h["Authorization"] || "").slice(-8)}`;
};

export const cachedGet = async (axios, path) => {
  const key = `oracle_cache:${path}:${authSignature()}`;
  try {
    const raw = sessionStorage.getItem(key);
    if (raw) {
      const { ts, data } = JSON.parse(raw);
      if (Date.now() - ts < CACHE_TTL_MS) return data;
    }
  } catch { /* cache miss */ }
  const r = await axios.get(`${ORACLE_API}${path}`, { headers: oracleAuthHeaders() });
  try {
    sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: r.data }));
  } catch { /* storage full — ignore */ }
  return r.data;
};

export const clearOracleCache = () => {
  try {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith("oracle_cache:"))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch { /* ignore */ }
};
